import { format, parseISO } from 'date-fns'

export function cn(...classes) {
  return classes.filter(Boolean).join(' ')
}

export function formatDate(dateString, pattern = 'MMM d, yyyy') {
  try {
    return format(parseISO(dateString), pattern)
  } catch {
    return dateString
  }
}

export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount)
}

export function getEventColor(event) {
  return event?.event_color ?? event?.calendars?.color ?? '#2d1b5e'
}

export function getInitials(name = '') {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('')
}
